/* eslint-disable multiline-ternary */
import Header from 'src/components/header/Header';
import { BackNavigation, Button, Card, ConditionalComponent, ConfirmModal, InfiniteScroll, Loader, Stepper, TStep } from 'src/components/common';
import { useGetIdentity, useToggleOpenModal, useUrlParamValue } from 'src/hooks';
import {
  CompanyCard,
  InviteNetwork
} from 'src/components/cards';
import IncubatorsCard from 'src/components/IncubatorsCard/IncubatorsCard';
import CreateCompanyNowCard from 'src/components/CreateCompanyNowCard/CreateCompanyNowCard';
import Banner from 'src/components/venture/banner/Banner';
import { useNavigate } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import { initialPostVentureValues } from './initalPostVentureValues';
import './venturepost.scss';
import { step1Schema, step2Schema, step3Schema } from './postventure.validationSchema';
import BasicInfo from 'src/components/venture/create-venture/BasicInfo';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { clearSingleVenture, createVenture, getDemoDay, getSingleVenture, updateVenture } from 'src/store/venture/venture.slice';
import TermGrowth from 'src/components/venture/create-venture/TermGrowth';
import Branding from 'src/components/venture/create-venture/Branding';
import { Col, Row } from 'react-bootstrap';
import { TGetCompany } from 'src/services/apiEndpoint.types.ts';
import { TVenture } from 'src/services/apiEndpoint.types.ts/ventures/ventures.types';
export const cancelPostModalModalId = 'cancelPostModalModal';
const PostVenture = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate()
  const { singleVenture, ventureLoading, demoDay, globalDemoDay } = useAppSelector(
    (store) => store.venture
  );
  const { paramValue } = useUrlParamValue();
  const { getIdentities } = useGetIdentity();
  const toggleOpenModal = useToggleOpenModal();
  const loading = useAppSelector((state) => state.common.loading);
  const modalId: string = useAppSelector((store: any) => store.common.modalId);
  const isDemoDayRunning = !!globalDemoDay?.[0]?.id;
  const { loggedInCompanyId, loggedInUserType, loggedInUserId } = getIdentities();
  const {
    myCompany
  }: {
    myCompany: TGetCompany;
  } = useAppSelector((store) => store.company);
  const [createVentureStep, setCreateVentureStep] = useState<number>(0);
  const [initialValue, setInitialValue] = useState<TVenture>(initialPostVentureValues);
  const [status, setStatus] = useState<string>('save')
  // constant 
  const id: string = paramValue({ paramName: 'id' }) as string;
  const type: string = paramValue({ paramName: 'type' }) as string;
  const prev: string = paramValue({ paramName: 'prev' }) as string;
  const isCancelPostVentureodalOpen = modalId === cancelPostModalModalId;
  const steps: TStep[] = [
    { label: 'Basic Info' },
    { label: 'Team & Growth' },
    { label: 'Branding & Hiring' }
  ];
  const handleToggleOpenCancelCreateProgramModal = () => {
    toggleOpenModal({ modalId: cancelPostModalModalId });
  };
  const sanitizeData = (data, nullishAllolwed: boolean = true) => {
    const modifiedData = { ...data };

    Object.keys(modifiedData).forEach((key) => {
      const value = modifiedData[key];

      // Remove objects where 'number' exists and is falsy
      if (typeof value === 'object' && 'number' in value && !value.number) {
        delete modifiedData[key];
      }

      // Remove empty arrays
      if (Array.isArray(value)) {
        modifiedData[key] = value.filter(
          (item) => item !== '' && !(typeof item === 'object' && Object.keys(item)?.length === 0)
        );

        if (modifiedData[key].length === 0) {
          delete modifiedData[key];
        }
      }
    });

    return modifiedData;
  };

  function handleBack() {
    if (prev && prev !== 'null') {
      navigate('/demo-day')
    } else if (createVentureStep > 0) {
      setCreateVentureStep((prev) => prev - 1)
    } else {
      navigate('/venture')
    }
  }
  console.log(isDemoDayRunning, 'isDemoDayRunning', demoDay);

  function handleSubmit(data: TVenture) {
    const modifiedData = sanitizeData(data)
    const payload: TVenture = {
      otherDomainInput: modifiedData.domain === 'Others' ? modifiedData.otherDomainInput : '',
      otherIncubatorName: modifiedData.otherIncubatorName === 'Others' ? modifiedData.otherIncubatorName : '',
      otherCoWorkingName: modifiedData.otherCoWorkingName === 'Others' ? modifiedData.otherCoWorkingName : '',
      linkCompanyPage: (loggedInUserType === 'Company' || !myCompany.id) ? false : modifiedData.linkCompanyPage,
      ...modifiedData,
      ...(loggedInUserType === 'Company' ? { companyId: loggedInCompanyId } : { userId: loggedInUserId }),
      ...(type !== 'edit' && status !== 'save' && { publishedTimestamp: new Date() }),
      draft: status === 'save' && type !== 'edit'
    }
    if (id) {
      dispatch(updateVenture({ ...payload, id })).then((response: { status: boolean; data: { status: boolean; message: string, data: any } }) => {
        if (response.data.status) {
          getMyVenture(response.data.data.id)
          // setInitialValue({ ...data, id: response.data.data.id })
          if (createVentureStep === 2) {
            if (isDemoDayRunning) {
              if (!demoDay && status === 'publish') {
                navigate(`/demo-day-register/payment?id=${response?.data?.data?.id}`)
              } else {
                navigate('/venture');
              }
            } else {
              navigate('/venture');
            }
          } else {
            setCreateVentureStep((prev) => prev + 1);
          }
        }
      })
    } else {
      dispatch(createVenture(payload)).then((response: { status: boolean; data: { status: boolean; message: string, data: any } }) => {
        if (response.data.status) {
          getMyVenture(response.data.data.id);
          if (prev && prev !== 'null') {
            navigate(`/post-venture?id=${response.data.data.id}&prev=${encodeURIComponent(prev)}`, { replace: true });
          } else {
            navigate(`/post-venture?id=${response.data.data.id}`, { replace: true });
          }
          if (createVentureStep === 2) {
            if (isDemoDayRunning) {
              if (!demoDay && status === 'publish') {
                navigate(`/demo-day-register/payment?id=${response?.data?.data?.id}`)
              } else {
                navigate('/venture')
              }
            } else {
              navigate('/venture')
            }
          } else {
            setCreateVentureStep((prev) => prev + 1);
          }
        }
      })
    }
  }
  const formStepComponent = (props: any) => {
    return {
      0: <BasicInfo {...props} />,
      1: <TermGrowth {...props} />,
      2: <Branding {...props} />
    }
  };
  const getMyVenture = useCallback((id: string) => {
    dispatch(getSingleVenture({ id }))

    return () => {
      dispatch(clearSingleVenture())
    }
  }, [id])
  const handleCancelProgram = () => {
    handleToggleOpenCancelCreateProgramModal();
    navigate('/venture');
  };
  useEffect(() => {
    if (id) {
      getMyVenture(id)
    }
  }, [id, getMyVenture])

  useEffect(() => {
    if (singleVenture) {
      dispatch(getDemoDay({ ventureVerseId: singleVenture?.id }))
      const data: TVenture = {
        id: singleVenture?.id,
        ...(singleVenture?.userId ? { userId: singleVenture?.userId } : { companyId: singleVenture?.companyId }),
        title: singleVenture?.title || '',
        description: singleVenture?.description || '',
        about: singleVenture?.about || '',
        domain: singleVenture?.domain || '',
        otherDomainInput: singleVenture?.otherDomainInput || '',
        ventureStage: singleVenture?.ventureStage || '',
        fundingStage: singleVenture?.fundingStage || '',
        websiteUrl: singleVenture?.websiteUrl || '',
        incubatorName: singleVenture?.incubatorName || '',
        otherIncubatorName: singleVenture?.otherIncubatorName || '',
        coWorkingName: singleVenture?.coWorkingName || '',
        otherCoWorkingName: singleVenture?.otherCoWorkingName || '',
        coFounders: singleVenture?.CoFounders?.map((item) => item.userId ? ({ id: item?.userId, userType: 'User' }) : ({ id: item?.Company?.id, userType: "Company" })) || [],
        noOfCustomers: singleVenture?.noOfCustomers || { number: "", hidden: false },
        teamSize: singleVenture?.teamSize || { number: "", hidden: false },
        linkCompanyPage: !!singleVenture?.linkCompanyPage || false,
        isHiring: singleVenture?.isHiring || false,
        isSeekingCofounderHiring: singleVenture?.isSeekingCofounderHiring || false,
        hiring: singleVenture?.VentureVerseHirings?.map((item) => (
          {
            title: item.title || '',
            domain: item.domain || '',
            description: item.description || ''
          }
        )) || [],
        logo: singleVenture?.logo || '',
        banner: singleVenture?.banner || '',
        draft: singleVenture?.draft || false
      }

      setInitialValue(data)
    }
  }, [singleVenture]);

  return (
    <>
      <InfiniteScroll className="dashboard" onScrollEnd={() => { }}
        loading={false}
        showLoader={false}
        showFooter={false}
        moreItemsLeft={false}
      >
        <Header />
        <div className="dashboard__body dashboard__newBody">
          <div className="dashboard__body__feed">
            <Banner isCreation={true} />
            <BackNavigation text='Back' onClick={handleBack} />
            <Stepper
              currentStep={createVentureStep}
              steps={steps}
              className="create-program__body__stepper"
            />
            <Card className="venture-details">
              <Formik initialValues={initialValue} validationSchema={createVentureStep === 0 ? step1Schema : createVentureStep === 1 ? step2Schema : step3Schema} onSubmit={handleSubmit} enableReinitialize={true}>
                {(props) => (
                  <Form className="venture-details__form">
                    {formStepComponent(props)[createVentureStep]}
                    <Row className='justify-content-center gap-2 mt-2'>
                      <Col md={3}>
                        <Button size='extraSmall' variant='secondary' onClick={handleToggleOpenCancelCreateProgramModal}>Cancel</Button>
                      </Col>
                      <Col md={3}>
                        <Button size='extraSmall' type="submit" style={createVentureStep === 2 ? {} : { minWidth: '130px' }} variant={createVentureStep === 2 ? 'secondary' : 'primary'} disabled={loading || ventureLoading}>
                          {loading && status === 'save' ? <Loader /> : createVentureStep === 2 ? 'Save as draft' : 'Save & Continue'}
                        </Button>
                      </Col>
                      {createVentureStep === 2 && <Col md={3}>
                        <Button size='extraSmall' type="submit" variant='primary' disabled={loading || ventureLoading} onClick={() => setStatus('publish')}>
                          {loading && status === 'publish' ? <Loader /> : 'Publish'}
                        </Button>
                      </Col>}
                    </Row>
                  </Form>
                )}
              </Formik>
            </Card>
          </div>
          <div className="dashboard__cards">

            <InviteNetwork />
            {loggedInUserType === 'User' && (
              <ConditionalComponent
                condition={Boolean(loggedInCompanyId)}
                whenTrue={<CompanyCard selfCompany={true} companyId={loggedInCompanyId} />}
                whenFalse={<CreateCompanyNowCard />}
              />
            )}

            <IncubatorsCard />
          </div>
        </div>
      </InfiniteScroll>
      {isCancelPostVentureodalOpen && (
        <ConfirmModal
          title="Are you sure you want to exit?"
          description=""
          openConfirmModal={isCancelPostVentureodalOpen}
          onClose={handleToggleOpenCancelCreateProgramModal}
          onSubmit={handleCancelProgram}
          submitText="Confirm"
          type="error"
        />
      )}
    </>
  );
};

export default PostVenture;
